import { PhoneService } from '@pbx/services/PhoneService';
import { snakeStore, PER_PAGE } from '@/plugins/vuex-async-pagginate';
import { getUID, isID } from '@shared/helpers/uid';

export const table = snakeStore(
  {
    state: {
      [PER_PAGE]: 10,
      changes: []
    },
    actions: {
      getData: ({ rootState, commit }, params) => {
        commit('changes', []);
        return PhoneService.getList(rootState['pbx']['phone-lists']['form']['id'], params);
      },

      addPhone: ({ getters, commit }, phone = '') => {
        const new_item = {
          id: getUID(),
          phone: phone
        };

        const old_items = getters['changes'];
        commit('changes', [...old_items, new_item]);
      },

      removePhone: ({ getters, commit }, item) => {
        commit('changes', [...getters['changes'], item]);
      },

      removeChange: ({ getters, commit }, id) => {
        const f = getters['changes'].filter(f => f.id !== id);
        commit('changes', f);
      },

      /* reset array of changes for clear ui table when create-form in use */
      resetChanges: ({ commit }) => {
        commit('changes', []);
      },
    },

    getters: {
      changes: state =>
        state.changes.map(i => {
          const state = isID(i.id) ? 'remove' : 'add';

          return {
            ...i,
            state
          };
        })
    },

    mutations: {
      changes: (state, value) => (state['changes'] = value)
    }
  },
  true
);
